import { object, string } from "yup";

const initialValues = ({ name = "", email = "", description = "" }) => ({
  name,
  email,
  description,
});

const validationSchema = object({
  name: string().trim().required("Required"),
  email: string().trim().email("Invalid email address").required("Required"),
  description: string().trim().required("Required"),
});

const reportBugInitialValues = {
  name: "",
  email: "",
  select_feature: "",
  bug_title: "",
  bug_description: "",
};

const reportBugValidationSchema = object({
  name: string().trim().required("Required"),
  email: string().trim().email("Invalid email address").required("Required"),
  select_feature: string().trim().required("Required"),
  bug_title: string().trim().required("Required"),
  bug_description: string().trim().required("Required"),
});

export {
  initialValues,
  validationSchema,
  reportBugInitialValues,
  reportBugValidationSchema,
};
